import * as React from "react";

import { ArrowRight } from "lucide-react";

import { cn } from "~/lib/utils";

// AIDEV-NOTE: FooterActionBar — full-width forest card-footer CTA with a
// trailing arrow. A gentle, human offer distinct from pill buttons; reads
// as help, not an upsell. forest-100 bar, forest-700 text, underline on hover.
// From the onboarding checklist design — see
// docs/specs/practitioner-onboarding-checklist.md.

export interface FooterActionBarProps
    extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    label: React.ReactNode;
    /** Renders inert + muted (no href, no hover) — e.g. when the target link isn't configured yet. */
    disabled?: boolean;
}

const FooterActionBar = React.forwardRef<
    HTMLAnchorElement,
    FooterActionBarProps
>(({ label, disabled = false, className, href, ...props }, ref) => (
    <a
        ref={ref}
        href={disabled ? undefined : href}
        aria-disabled={disabled || undefined}
        className={cn(
            "group flex items-center justify-center gap-2 bg-brand-forest-100 px-4 py-[13px] no-underline transition-colors duration-200",
            disabled ? "cursor-default opacity-60" : "cursor-pointer",
            className,
        )}
        {...props}
    >
        <span
            className={cn(
                "font-body text-[13px] font-semibold tracking-[-0.1px] text-brand-forest-700",
                !disabled && "group-hover:underline",
            )}
        >
            {label}
        </span>
        <ArrowRight className="size-[15px] shrink-0 stroke-2 text-brand-forest-700 transition-transform duration-200 group-hover:translate-x-0.5" />
    </a>
));
FooterActionBar.displayName = "FooterActionBar";

export { FooterActionBar };
